import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/**
 * Purpose: <RequireAuth> — gate that renders children only when the user
 *          is authenticated. While loading, renders an optional
 *          `loading` slot (or nothing). When unauthenticated, renders
 *          the `fallback` slot if provided, or auto-triggers a redirect
 *          to the IdP.
 *
 * Implementation notes:
 *   - Use the `fallback` form when the unauthenticated state should
 *     surface UI (e.g. a branded login screen with a button); use the
 *     no-fallback form for routes where an immediate redirect is
 *     desired.
 *   - The auto-redirect runs from an effect to avoid invoking
 *     `login()` during render.
 *
 * Created: 2026-04-30 11:00
 *
 * Changelog:
 *   - 2026-04-30 11:00 — Initial version.
 */
import { useEffect } from 'react';
import { useAuth } from './AuthProvider.js';
export function RequireAuth({ children, fallback, loading, }) {
    const { isLoading, isAuthenticated, login } = useAuth();
    useEffect(() => {
        if (!isLoading && !isAuthenticated && fallback === undefined) {
            void login();
        }
    }, [isLoading, isAuthenticated, fallback, login]);
    if (isLoading)
        return _jsx(_Fragment, { children: loading ?? null });
    if (!isAuthenticated)
        return _jsx(_Fragment, { children: fallback ?? null });
    return _jsx(_Fragment, { children: children });
}
//# sourceMappingURL=RequireAuth.js.map